/* global Word, console */

import { getCoObjectDocumentPartInclude } from "../api/object/CoObjectGeneral";

export interface DocumentPartRelativePosition {
  contentControlId: number;
  contentControlOrder: number;
  relativePosition: "before" | "after";
}

export const checkIfPartExists = async (
  documentId: string,
  partOrder: number,
  fatherDocumentId: string
): Promise<void> => {
  const coObjectDocumentPartInclude = await getCoObjectDocumentPartInclude(fatherDocumentId, documentId, partOrder);

  if (!coObjectDocumentPartInclude || !coObjectDocumentPartInclude.contentControlId) {
    throw new Error("Invalid document part include or missing content control ID.");
  }

  await Word.run(async (context) => {
    const contentControl = await getContentControlById(context, parseInt(coObjectDocumentPartInclude.contentControlId));
    if (!contentControl) {
      throw new Error("Content control not found.");
    }
  });
};

export const getContentControlById = async (context: Word.RequestContext, contentControlId: number) => {
  const contentControls = context.document.contentControls;
  contentControls.load();
  await context.sync();
  return contentControls.items.find((cc) => cc.id === contentControlId);
};

export const insertDocumentPart = async (title: string, position?: DocumentPartRelativePosition): Promise<string> => {
  return Word.run(async (context) => {
    const EMPTY_TEXT = "";
    let paragraph: Word.Paragraph;

    if (position) {
      const selectedCc = await getContentControlById(context, position.contentControlId);
      if (!selectedCc) {
        throw new Error(`No content control found for the given id: ${position.contentControlId}`);
      }

      paragraph = selectedCc.insertParagraph(
        EMPTY_TEXT,
        position.relativePosition === "before" ? Word.InsertLocation.before : Word.InsertLocation.after
      );
      selectedCc.insertParagraph(
        EMPTY_TEXT,
        position.relativePosition === "before" ? Word.InsertLocation.before : Word.InsertLocation.after
      );
    } else {
      const emptyParagraph = context.document.body.insertParagraph(EMPTY_TEXT, Word.InsertLocation.end);
      paragraph = emptyParagraph.insertParagraph(EMPTY_TEXT, Word.InsertLocation.after);
    }

    const cc = paragraph.insertContentControl();

    cc.title = title;
    cc.cannotEdit = true;
    cc.cannotDelete = true;

    await context.sync();
    return cc.id.toString();
  }).catch((error) => {
    console.error(error);
    throw error;
  });
};

export const moveCursorToContentControlId = (contentControlId: number) =>
  new Promise<void>((resolve, reject) =>
    Word.run(async (context) => {
      const contentControl = context.document.contentControls.getByIdOrNullObject(Number(contentControlId));
      await context.sync();
      if (contentControl.isNullObject) throw new Error(`No contentControl found for the given id ${contentControlId}`);
      contentControl.select();
      resolve();
    }).catch((error) => {
      // eslint-disable-next-line no-undef
      console.error(error);
      reject(error);
    })
  );
